'use client';

import Link from 'next/link';

import { cn } from '@/libs';

import { useCookieConsent } from './hooks';

import { Button } from '../ui';

export const CookieConsent = () => {
  const {
    isVisible,
    isMounted,
    cookiesPolicyLink,
    privacyPolicyLink,
    handleAccept,
    handleReject,
  } = useCookieConsent();

  if (!isMounted) {
    return null;
  }

  return (
    <div>
      {isVisible && (
        <div
          key="cookie-consent"
          className={cn(
            'relative w-full z-[49]',
            'bg-background border-b border-foreground/20',
            'shadow-md',
          )}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="max-w-screen-xl mx-auto px-4 py-5 md:py-6">
            <div className="flex flex-col md:flex-row items-start md:items-center gap-5 md:gap-6">
              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-semibold mb-2.5 text-foreground">
                  Política de Cookies
                </h3>
                <p className="text-xs md:text-sm text-foreground/80 leading-relaxed">
                  Utilizamos cookies para melhorar sua experiência, analisar o tráfego do
                  site e personalizar conteúdo. Ao continuar navegando, você concorda com
                  o uso de cookies. Para mais informações, consulte nossos{' '}
                  <Link
                    href={cookiesPolicyLink}
                    className="text-primary underline hover:text-primary-hover transition-colors cursor-pointer font-medium"
                  >
                    Termos de Uso
                  </Link>{' '}
                  sobre Cookies e nossa{' '}
                  <Link
                    href={privacyPolicyLink}
                    className="text-primary underline hover:text-primary-hover transition-colors cursor-pointer font-medium"
                  >
                    Termos de Uso
                  </Link>{' '}
                  sobre Cookies e nossa{' '}
                  <Link
                    href={privacyPolicyLink}
                    className="text-primary underline hover:text-primary-hover transition-colors cursor-pointer"
                  >
                    Política de Privacidade
                  </Link>
                  .
                </p>
              </div>
              <div className="flex flex-row gap-3 w-full md:w-auto md:flex-shrink-0">
                <Button
                  variant="outlined"
                  size="regular"
                  onClick={handleReject}
                  className="flex-1 sm:flex-none sm:w-auto min-w-[130px] px-5 md:px-6 font-semibold border-foreground/30 hover:border-foreground/50 transition-all"
                >
                  Rejeitar
                </Button>
                <Button
                  variant="primary"
                  size="regular"
                  onClick={handleAccept}
                  className="flex-1 sm:flex-none sm:w-auto min-w-[130px] px-5 md:px-6 font-semibold shadow-sm hover:shadow-md transition-shadow"
                >
                  Aceitar
                </Button>
                {/* <Button
                  variant="ghost"
                  size="regular"
                  as={Link}
                  href={cookiesPreferencesLink}
                  className="w-full sm:w-auto min-w-[130px] px-5 md:px-6 text-foreground/70 hover:text-foreground hover:bg-foreground/5 font-medium transition-all"
                >
                  Preferências
                </Button> */}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
